import { EM_DASH } from '../../constants/generic.constants';
import { useDateTime } from '../../hooks';
export const FormattedDateTime = ({ date, timeZone }) => {
    const { parseDateTimeShort } = useDateTime();
    if (!date) {
        return EM_DASH;
    }
    return parseDateTimeShort(date, { timeZone });
};
